/* eslint-disable no-undef */
import React, { useState } from 'react';
import ConciliacaoBancariaAdd from './add';
import ConciliacaoBancariaSearch from './search';

export default function ConciliacaoBancaria() {
  const [option, setOption] = useState('search');
  return (
    <div>
      {option === 'search' && <ConciliacaoBancariaSearch setOption={setOption} />}
      {option === 'add' && <ConciliacaoBancariaAdd setOption={setOption} />}
    </div>
  );
}
